import { type FC, useCallback } from 'react'

import { type UseMutationResult } from 'react-query'

import { Dialog } from '@/components/ui/dialog'
import type { DialogProps } from '@/dialogs/types'

import type {
  AccountAuthResponse,
  AccountLoginRequest,
} from '../../modules/accounts/types'
import { LoginForm } from '../../modules/accounts/ui/AccountLoginForm'
import type { LoginResult } from './types'

interface Props extends DialogProps {
  loginMutation: UseMutationResult<
    AccountAuthResponse,
    unknown,
    AccountLoginRequest,
    unknown
  >
  onAddUser: (body: LoginResult) => void
}

export const AddAccountDialog: FC<Props> = ({
  onAddUser,
  loginMutation,
  isOpen,
  onClose,
}) => {
  const handleFinish = useCallback(
    (body: LoginResult) => {
      onAddUser(body)
      onClose()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onAddUser],
  )

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      className="w-[312px]"
    >
      <LoginForm
        onFinish={handleFinish}
        loginMutation={loginMutation}
      />
    </Dialog>
  )
}
